<template>
  <v-app id="inspire">
    <v-main>
      <v-container>
        <v-row
          justify="center"
          align="center"
          style="margin-top: 5%"
        >
        <h1>Playlist stored!</h1>
          <v-col class="shrink">
            <v-icon large>mdi-playlist-check</v-icon>
          </v-col>
        </v-row>
      </v-container>
      <v-row align="center">
        <v-col class="text-center" cols="12" sm="4">
        </v-col>
        <v-col class="text-center" cols="12" sm="4">
            <v-btn large outlined color="green" @click="home()">Create another list</v-btn>
        </v-col>
        <v-col class="text-center" cols="12" sm="4">
          <div class="my-2">
            <v-btn large color="green" @click="toPlaylist()">Open list in spotify</v-btn>
          </div>
        </v-col>
      </v-row>
    </v-main>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    source: String
  },
  data: () => ({
    drawer: null
  }),
  computed: {
    ...mapGetters({
      latestCreatedPlaylist: 'getLatestCreated'
    })
  },
  methods: {
    home () {
      this.$store.commit('resetFriends')
      this.$store.commit('resetPlaylist')
      this.$store.dispatch('fetchFollows')
      this.$router.push('/')
    },
    toPlaylist () {
      console.log(this.latestCreatedPlaylist)
      window.open(this.latestCreatedPlaylist.external_urls.spotify)
    }
  },
  created () {
    this.$vuetify.theme.dark = true
  }
}
</script>
